<div class="row">
  <div class="rs-flex-columns small-12 medium-4">
    <div class="rs-form-neg">
      <div class="rs-form-item rs-padding-bottom4">
        <select
          id="ac-selectbox1-neg"
          name="ac-selectbox1-neg"
          class="rs-filled"
          (change)="selectAddress($event.target.value)"
          data-tms-event="filter-click"
          data-tms-filter-zone="product overview"
          data-tms-filter-name="address selector"
        >
          <option value="0" selected="">
            {{ 'products.overview.selector.all' | translate }}
          </option>
          <option *ngFor="let address of addresses | keyvalue" value="{{ address.key }}">
            <mprd-address [address]="address.value"></mprd-address>
          </option>
          <option *ngIf="showNoAddress" value="noaddress">
            {{ 'products.overview.selector.noAddress' | translate }}
          </option>
        </select>
        <label class="rs-form-label" for="ac-selectbox1-neg">
          {{ 'products.overview.selector.messageLabel' | translate }}
        </label>
      </div>
    </div>
  </div>
</div>
